import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReservationComponent } from './reservation.component';
import { RESERVATION_PAGE_PATH } from '../shared/constants';

const routes: Routes = [
  {
    path: RESERVATION_PAGE_PATH,
    component: ReservationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReservationRoutingModule {}
